export default __webpack_public_path__ + "static/media/publicity-team-member-5.947bae39.jpg";